import { FileText, Plus, X } from 'lucide-react'

import type { OrderTab } from './pos-types'

interface Props {
    tabs: OrderTab[]
    activeTabId: string
    onSwitch: (id: string) => void
    onAdd: () => void
    onClose: (id: string) => void
}

export function PosOrderTabs({
    tabs,
    activeTabId,
    onSwitch,
    onAdd,
    onClose,
}: Props) {
    return (
        <div className="flex items-center gap-0.5 overflow-x-auto max-w-[50vw]">
            {tabs.map((tab) => {
                const isActive = tab.id === activeTabId
                return (
                    <div
                        key={tab.id}
                        className={`flex items-center gap-1 px-3 py-1.5 rounded-t text-sm cursor-pointer whitespace-nowrap transition-colors ${
                            isActive
                                ? 'bg-primary-foreground/20 text-primary-foreground font-medium'
                                : 'text-primary-foreground/70 hover:bg-primary-foreground/10'
                        }`}
                        onClick={() => onSwitch(tab.id)}
                    >
                        <FileText className="size-3.5" />
                        <span>{tab.label}</span>
                        {tabs.length > 1 && (
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onClose(tab.id)
                                }}
                                className="ml-1 p-0.5 rounded hover:bg-primary-foreground/20"
                            >
                                <X className="size-3" />
                            </button>
                        )}
                    </div>
                )
            })}
            <button
                type="button"
                onClick={onAdd}
                className="flex items-center gap-1 px-2 py-1.5 text-primary-foreground/70 hover:bg-primary-foreground/10 rounded text-sm"
            >
                <Plus className="size-3.5" />
            </button>
        </div>
    )
}
